import React from "react";
import { useTranslation } from "react-i18next";
import { isVkConfigured } from "../../platform/social/vk";
import { IS_TELEGRAM } from "../../platform";
import "./SocialAuthButtons.css";

interface SocialAuthButtonsProps {
  onVk?: () => void;
  onBridge?: (provider: "vk") => void;
}

const IMG = (name: string) => `${process.env.PUBLIC_URL}/images/${name}`;

const SocialAuthButtons: React.FC<SocialAuthButtonsProps> = ({ onVk, onBridge }) => {
  const { t } = useTranslation();

  // Inside the Telegram WebView, hand VK auth off to the system browser.
  if (IS_TELEGRAM && onBridge) {
    const showVkBridge = isVkConfigured();
    if (!showVkBridge) return null;
    return (
      <div className="social-auth">
        <div className="social-auth-divider">{t("auth.orContinueWith")}</div>
        <button
          type="button"
          className="social-auth-btn social-auth-btn--vk"
          data-testid="bridge-btn-vk"
          onClick={() => onBridge("vk")}
        >
          <img className="social-auth-btn__icon" src={IMG("vk_flat.png")} alt="" aria-hidden="true" />
          <span className="social-auth-btn__label">{t("auth.continueWithVk")}</span>
        </button>
      </div>
    );
  }

  const showVk = !!onVk && isVkConfigured();
  if (!showVk) return null;

  return (
    <div className="social-auth">
      <div className="social-auth-divider">{t("auth.orContinueWith")}</div>
      <button
        type="button"
        className="social-auth-btn social-auth-btn--vk"
        data-testid="vk-btn"
        onClick={onVk}
      >
        <img className="social-auth-btn__icon" src={IMG("vk_flat.png")} alt="" aria-hidden="true" />
        <span className="social-auth-btn__label">{t("auth.continueWithVk")}</span>
      </button>
    </div>
  );
};

export default SocialAuthButtons;
